let api = require('../../api/config')
let url = api.default.api


function _iterableToArrayLimit(e, n) {
    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != o) {
        var t, r, i, a, c = [], u = !0, l = !1;
        try {
            if (i = (o = o.call(e)).next, 0 === n) {
                if (Object(o) !== o) return;
                u = !1
            } else for (; !(u = (t = i.call(o)).done) && (c.push(t.value), c.length !== n); u = !0) ;
        } catch (e) {
            l = !0, r = e
        } finally {
            try {
                if (!u && null != o.return && (a = o.return(), Object(a) !== a)) return
            } finally {
                if (l) throw r
            }
        }
        return c
    }
}

function _slicedToArray(e, n) {
    return _arrayWithHoles(e) || _iterableToArrayLimit(e, n) || _unsupportedIterableToArray(e, n) || _nonIterableRest()
}

function _toConsumableArray(e) {
    return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread()
}

function _arrayWithoutHoles(e) {
    if (Array.isArray(e)) return _arrayLikeToArray(e)
}

function _arrayWithHoles(e) {
    if (Array.isArray(e)) return e
}

function _iterableToArray(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
}

function _unsupportedIterableToArray(e, n) {
    var o;
    if (e) return "string" == typeof e ? _arrayLikeToArray(e, n) : "Map" === (o = "Object" === (o = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : o) || "Set" === o ? Array.from(e) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? _arrayLikeToArray(e, n) : void 0
}

function _arrayLikeToArray(e, n) {
    (null == n || n > e.length) && (n = e.length);
    for (var o = 0, t = new Array(n); o < n; o++) t[o] = e[o];
    return t
}

function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}

var summary = {
    PM25: {
        domainAndColor: [{min: 0, max: 5, color: "#34b300"}, {min: 5, max: 10, color: "#3ecf00"}, {
            min: 10,
            max: 15,
            color: "#46e800"
        }, {min: 15, max: 20, color: "#99fd0b"}, {min: 20, max: 25, color: "#a9ff00"}, {
            min: 25,
            max: 30,
            color: "#daff00"
        }, {min: 30, max: 35, color: "#fdff00"}, {min: 35, max: 40, color: "#fcea00"}, {
            min: 40,
            max: 45,
            color: "#fad200"
        }, {min: 45, max: 50, color: "#f9bd00"}, {min: 50, max: 60, color: "#f78900"}, {
            min: 60,
            max: 70,
            color: "#f66400"
        }, {min: 70, max: 80, color: "#f50000"}, {min: 80, max: 90, color: "#c60000"}, {
            min: 90,
            max: 100,
            color: "#9d0056"
        }, {min: 100, max: 110, color: "#830024"}], unit: "μg/m³", formatter: function (e) {
            return round(e, 0)
        }
    },
    PM10: {
        unit: "μg/m³",
        formatter: function (e) {
            return round(e, 0)
        },
        domainAndColor: [{min: 0, max: 10, color: "#34b300"}, {min: 10, max: 20, color: "#3ecf00"}, {
            min: 20,
            max: 30,
            color: "#46e800"
        }, {min: 30, max: 40, color: "#99fd0b"}, {min: 40, max: 50, color: "#a9ff00"}, {
            min: 50,
            max: 60,
            color: "#daff00"
        }, {min: 60, max: 70, color: "#fdff00"}, {min: 70, max: 80, color: "#fcea00"}, {
            min: 80,
            max: 90,
            color: "#fad200"
        }, {min: 90, max: 100, color: "#f9bd00"}, {min: 100, max: 120, color: "#f78900"}, {
            min: 120,
            max: 140,
            color: "#f66400"
        }, {min: 140, max: 160, color: "#f50000"}, {min: 160, max: 180, color: "#c60000"}, {
            min: 180,
            max: 200,
            color: "#9d0056"
        }, {min: 200, max: 220, color: "#830024"}]
    },
    O3: {
        formatter: function (e) {
            return round(e, 0)
        },
        unit: "μg/m³",
        domainAndColor: [{max: 50, min: 0, color: "#34b300"}, {min: 50, max: 60, color: "#46e800"}, {
            min: 60,
            max: 70,
            color: "#4fff00"
        }, {min: 70, max: 80, color: "#a9ff00"}, {min: 80, max: 90, color: "#fdff00"}, {
            min: 90,
            max: 100,
            color: "#fcea00"
        }, {min: 100, max: 120, color: "#fad200"}, {min: 120, max: 140, color: "#f9bd00"}, {
            min: 140,
            max: 160,
            color: "#f78900"
        }, {min: 160, max: 180, color: "#f66400"}, {min: 180, max: 200, color: "#f50000"}, {
            min: 200,
            max: 250,
            color: "#c60000"
        }, {min: 250, max: 300, color: "#9d0056"}]
    },
    O3TCD: {
        formatter: function (e) {
            return round(e, 0)
        },
        unit: "μg/m³",
        domainAndColor: [{max: 100, min: 0, color: "#34b300"}, {min: 100, max: 120, color: "#46e800"}, {
            min: 120,
            max: 160,
            color: "#4fff00"
        }, {min: 160, max: 180, color: "#a9ff00"}, {min: 180, max: 200, color: "#fdff00"}, {
            min: 200,
            max: 220,
            color: "#fcea00"
        }, {min: 220, max: 240, color: "#fad200"}, {min: 240, max: 260, color: "#f9bd00"}, {
            min: 280,
            max: 300,
            color: "#f78900"
        }, {min: 300, max: 320, color: "#f66400"}, {min: 320, max: 340, color: "#f50000"}, {
            min: 340,
            max: 380,
            color: "#c60000"
        }, {min: 380, max: 400, color: "#9d0056"}]
    },
    HCHO: {
        unit: "1e16molec./c㎡",
        formatter: function (e) {
            return round(e, 2)
        },
        domainAndColor: [{min: 0, max: .2, color: "#0000ff"}, {min: .2, max: .4, color: "#0f64ff"}, {
            min: .4,
            max: .6,
            color: "#37a5ff"
        }, {min: .6, max: .8, color: "#10cffd"}, {min: .8, max: 1, color: "#26feb7"}, {
            min: 1,
            max: 1.2,
            color: "#bcfe58"
        }, {min: 1.2, max: 1.4, color: "#f1fc14"}, {min: 1.4, max: 1.6, color: "#ff0000"}]
    },
    CH4: {
        domain: [1800, 1850, 1900, 2e3, 2100, 2200, 2300, 2400],
        colors: ["#5fd9fb", "#4ae3ce", "#e8feb5", "#fdedb1", "#eec07d", "#fdb65a", "#d50b55", "#7f213f"],
        unit: "ppb",
        formatter: function (e) {
            return round(e, 0)
        },
        domainAndColor: [{max: 1800, min: 0, color: "#5fd9fb"}, {min: 1800, max: 1850, color: "#4ae3ce"}, {
            min: 1850,
            max: 1900,
            color: "#e8feb5"
        }, {min: 1900, max: 2e3, color: "#fdedb1"}, {min: 2e3, max: 2100, color: "#eec07d"}, {
            min: 2100,
            max: 2200,
            color: "#fdb65a"
        }, {min: 2200, max: 2300, color: "#d50b55"}, {min: 2300, max: 2400, color: "#7f213f"}]
    },
    CO: {
        unit: "1e19molec./cm²",
        domain: [0, .1, .16, .2, .25, .3],
        colors: ["#00fe00", "#88f700", "#f5f100", "#fc9900", "#f50000", "#f50000"],
        formatter: function (e) {
            return round(e, 3)
        },
        domainAndColor: [{min: 0, max: .1, color: "#00fe00"}, {min: .1, max: .16, color: "#88f700"}, {
            min: .16,
            max: .2,
            color: "#f5f100"
        }, {min: .2, max: .25, color: "#fc9900"}, {min: .25, max: .3, color: "#f50000"}]
    },
    SO2: {
        unit: "du",
        domain: [0, .2, .4, .6, .8, 1, 1.2, 1.4, 1.6],
        colors: ["#1621c6", "#3675ff", "#10cffd", "#26feb7", "#bcfe58", "#f1fc14", "#faac00", "#fc3200", "#fc3200"],
        formatter: function (e) {
            return round(e, 2)
        },
        domainAndColor: [{min: 0, max: .2, color: "#1621c6"}, {min: .2, max: .4, color: "#3675ff"}, {
            min: .4,
            max: .6,
            color: "#10cffd"
        }, {min: .6, max: .8, color: "#26feb7"}, {min: .8, max: 1, color: "#bcfe58"}, {
            min: 1,
            max: 1.2,
            color: "#f1fc14"
        }, {min: 1.2, max: 1.4, color: "#faac00"}, {min: 1.4, max: 1.6, color: "#fc3200"}]
    },
    CO2: {
        unit: "PPM",
        formatter: function (e) {
            return round(e, 0)
        },
        domain: [390, 400, 404, 406, 410, 414, 418, 420, 424],
        colors: ["#218ba8", "#199ebf", "#5adccc", "#f9fcb4", "#fdf0a3", "#fdb65a", "#d50b55", "#7f213f", "#7f213f"],
        domainAndColor: [{max: 390, color: "#288cf9"}, {min: 390, max: 400, color: "#01a0ff"}, {
            min: 400,
            max: 402,
            color: "#00c8c7"
        }, {min: 402, max: 404, color: "#00dc00"}, {min: 404, max: 406, color: "#a1e632"}, {
            min: 406,
            max: 410,
            color: "#e6dc33"
        }, {min: 410, max: 414, color: "#e6af2d"}, {min: 414, max: 418, color: "#f08227"}, {
            min: 418,
            max: 420,
            color: "#e84444"
        }, {min: 420, max: 422, color: "#ef0082"}]
    },
    AOD: {
        unit: "",
        formatter: function (e) {
            return round(e, 2)
        },
        domain: [.1, .2, .3, .4, .5, .6, .7, .8, .9, 1, 1.1, 1.2, 1.3, 1.4, 1.5],
        colors: ["#2800FF", "#0F64FF", "#37A5FF", "#5FCDFF", "#87FFFF", "#80FF80", "#80FF00", "#BAEF01", "#DCFB04", "#FFFF00", "#FDE302", "#FDCB02", "#FD9302", "#ED6703", "#FF0000"],
        domainAndColor: [{min: 0, max: .1, color: "#2800ff"}, {min: .1, max: .2, color: "#0f64ff"}, {
            min: .2,
            max: .3,
            color: "#37a5ff"
        }, {min: .3, max: .4, color: "#5fcdff"}, {min: .4, max: .5, color: "#87ffff"}, {
            min: .5,
            max: .6,
            color: "#80ff80"
        }, {min: .6, max: .7, color: "#80ff00"}, {min: .7, max: .8, color: "#baef01"}, {
            min: .8,
            max: .9,
            color: "#dcfb04"
        }, {min: .9, max: 1, color: "#ffff00"}, {min: 1, max: 1.1, color: "#fde302"}, {
            min: 1.1,
            max: 1.2,
            color: "#fdcb02"
        }, {min: 1.2, max: 1.3, color: "#fd9302"}, {min: 1.3, max: 1.4, color: "#ed6703"}, {
            min: 1.4,
            max: 1.5,
            color: "#ff0000"
        }]
    },
    NO2TCD: {
        unit: "1e16molec./c㎡",
        formatter: function (e) {
            return round(e, 2)
        },
        domainAndColor: [{min: 0, max: .2, color: "#0000ff"}, {min: .2, max: .4, color: "#0f64ff"}, {
            min: .4,
            max: .6,
            color: "#37a5ff"
        }, {min: .6, max: .8, color: "#10cffd"}, {min: .8, max: 1, color: "#26feb7"}, {
            min: 1,
            max: 1.2,
            color: "#bcfe58"
        }, {min: 1.2, max: 1.6, color: "#f1fc14"}, {min: 1.6, max: 2, color: "#ff0000"}]
    },
    NO2: {
        unit: "μg/m³",
        domain: [0, 5, 10, 15, 20, 25, 30, 40, 60, 80, 100, 120, 140, 160, 180, 200, 250],
        formatter: function (e) {
            return round(e, 0)
        },
        colors: ["#34b300", "#3ecf00", "#46e800", "#4fff00", "#a9ff00", "#daff00", "#fdff00", "#fcea00", "#fad200", "#f9bd00", "#f78900", "#f66400", "#f50000", "#c60000", "#b50000", "#9d0056", "#830024"],
        domainAndColor: [{min: 0, max: 5, color: "#34b300"}, {min: 5, max: 10, color: "#3ecf00"}, {
            min: 10,
            max: 15,
            color: "#46e800"
        }, {min: 15, max: 20, color: "#4fff00"}, {min: 20, max: 25, color: "#a9ff00"}, {
            min: 25,
            max: 30,
            color: "#daff00"
        }, {min: 30, max: 40, color: "#fdff00"}, {min: 40, max: 60, color: "#fcea00"}, {
            min: 60,
            max: 80,
            color: "#fad200"
        }, {min: 80, max: 100, color: "#f9bd00"}, {min: 100, max: 120, color: "#f78900"}, {
            min: 120,
            max: 140,
            color: "#f66400"
        }, {min: 140, max: 160, color: "#f50000"}, {min: 160, max: 180, color: "#c60000"}, {
            min: 180,
            max: 200,
            color: "#b50000"
        }, {min: 200, max: 250, color: "#9d0056"}, {min: 250, color: "#830024"}]
    },
    UVA: {
        unit: "W/m²",
        formatter: function (e) {
            return round(e, 0)
        },
        domain: [0, 10, 20, 40, 50, 60, 70, 80],
        colors: ["#218ba8", "#199ebf", "#5adccc", "#f9fcb4", "#fdf0a3", "#fdb65a", "#d50b55", "#7f213f"],
        domainAndColor: [{max: 10, color: "#218ba8"}, {min: 10, max: 20, color: "#199ebf"}, {
            min: 20,
            max: 30,
            color: "#5adccc"
        }, {min: 40, max: 50, color: "#f9fcb4"}, {min: 50, max: 60, color: "#fdf0a3"}, {
            min: 60,
            max: 70,
            color: "#fdb65a"
        }, {min: 70, max: 80, color: "#d50b55"}, {min: 80, color: "#7f213f"}]
    },
    UVB: {
        unit: "W/m²",
        formatter: function (e) {
            return round(e, 1)
        },
        domain: [0, .5, 1, 1.5, 2, 4, 5, 6],
        colors: ["#218ba8", "#199ebf", "#5adccc", "#f9fcb4", "#fdf0a3", "#fdb65a", "#d50b55", "#7f213f"],
        domainAndColor: [{max: .5, color: "#218ba8"}, {min: .5, max: 1, color: "#199ebf"}, {
            min: 1,
            max: 1.5,
            color: "#5adccc"
        }, {min: 1.5, max: 2, color: "#f9fcb4"}, {min: 2, max: 4, color: "#fdf0a3"}, {
            min: 4,
            max: 5,
            color: "#fdb65a"
        }, {min: 5, max: 6, color: "#d50b55"}, {min: 6, color: "#7f213f"}]
    },
    UVT: {
        domainAndColor: [{max: 10, color: "#218ba8"}, {min: 10, max: 20, color: "#199ebf"}, {
            min: 20,
            max: 30,
            color: "#5adccc"
        }, {min: 40, max: 50, color: "#f9fcb4"}, {min: 50, max: 60, color: "#fdf0a3"}, {
            min: 60,
            max: 70,
            color: "#fdb65a"
        }, {min: 70, max: 80, color: "#d50b55"}, {min: 80, color: "#7f213f"}], unit: "W/m²", formatter: function (e) {
            return round(e, 0)
        }
    },
    TMP: {
        unit: "℃",
        domain: [0, 5, 10, 15, 20, 25, 30, 35],
        colors: ["#01a0ff", "#00c8c7", "#00dc00", "#a1e632", "#e6dc33", "#e6af2d", "#f08227", "#e84444"],
        formatter: function (e) {
            return round(e, 1)
        },
        domainAndColor: [{max: 0, color: "#288cf9"}, {min: 0, max: 5, color: "#01a0ff"}, {
            min: 5,
            max: 10,
            color: "#00c8c7"
        }, {min: 10, max: 15, color: "#00dc00"}, {min: 15, max: 20, color: "#a1e632"}, {
            min: 20,
            max: 25,
            color: "#e6dc33"
        }, {min: 25, max: 30, color: "#e6af2d"}, {min: 30, max: 35, color: "#f08227"}, {min: 35, color: "#e84444"}]
    },
    VIS: {
        unit: "km",
        formatter: function (e) {
            return round(e, 2)
        },
        domain: [0, .2, .5, 1, 2, 3, 5, 10, 20, 30],
        colors: ["#7325f9", "#9c00ff", "#b30101", "#fe5104", "#fcb346", "#fffe00", "#7afb33", "#93de2f", "#92d9ff", "#c1eefd"],
        domainAndColor: [{min: 0, max: .2, color: "#7325f9"}, {min: .2, max: .5, color: "#9c00ff"}, {
            min: .5,
            max: 1,
            color: "#b30101"
        }, {min: 1, max: 2, color: "#fe5104"}, {min: 2, max: 3, color: "#fcb346"}, {
            min: 3,
            max: 5,
            color: "#fffe00"
        }, {min: 5, max: 10, color: "#7afb33"}, {min: 10, max: 20, color: "#93de2f"}, {
            min: 20,
            max: 30,
            color: "#92d9ff"
        }, {min: 30, max: 40, color: "#c1eefd"}]
    },
    PRE: {
        unit: "mm",
        domain: [0, 2, 10, 50],
        colors: ["#99fe99", "#67cbff", "#0010dd", "#eb25ec"],
        formatter: function (e) {
            return round(e, 1)
        },
        domainAndColor: [{min: 0, max: 2, color: "#99fe99"}, {min: 2, max: 10, color: "#67cbff"}, {
            min: 10,
            max: 50,
            color: "#0010dd"
        }, {min: 50, color: "#eb25ec"}]
    },
    PRS: {
        unit: "hPa",
        domain: [0, 550, 600, 650, 700, 750, 800, 850, 900, 1100],
        formatter: function (e) {
            return round(e, 0)
        },
        colors: ["#288cf9", "#01a0ff", "#00c8c7", "#00dc00", "#a1e632", "#e6dc33", "#e6af2d", "#f08227", "#e84444", "#ef0082"],
        domainAndColor: [{max: 500, color: "#288cf9"}, {min: 500, max: 550, color: "#01a0ff"}, {
            min: 550,
            max: 600,
            color: "#00c8c7"
        }, {min: 600, max: 650, color: "#00dc00"}, {min: 650, max: 700, color: "#a1e632"}, {
            min: 700,
            max: 750,
            color: "#e6dc33"
        }, {min: 750, max: 800, color: "#e6af2d"}, {min: 800, max: 850, color: "#f08227"}, {
            min: 850,
            max: 900,
            color: "#e84444"
        }, {min: 900, color: "#ef0082"}]
    },
    RH: {
        unit: "%",
        domain: [0, 45, 55, 65, 75, 85, 90, 95, 100],
        formatter: function (e) {
            return round(e, 0)
        },
        colors: ["#01a0ff", "#00c8c7", "#00dc00", "#a1e632", "#e6dc33", "#e6af2d", "#f08227", "#e84444", "#ef0082"],
        domainAndColor: [{max: 0, color: "#288cf9"}, {min: 0, max: 45, color: "#01a0ff"}, {
            min: 45,
            max: 55,
            color: "#00c8c7"
        }, {min: 55, max: 65, color: "#00dc00"}, {min: 65, max: 75, color: "#a1e632"}, {
            min: 75,
            max: 85,
            color: "#e6dc33"
        }, {min: 85, max: 90, color: "#e6af2d"}, {min: 90, max: 95, color: "#f08227"}, {
            min: 95,
            max: 100,
            color: "#e84444"
        }, {min: 100, color: "#ef0082"}]
    }
}, decoders = ([].concat(_toConsumableArray(Object.keys(summary)), ["TCOLOR", "DCOLOR"]), {
    PM25: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, PM10: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, O3: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, O3TCD: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, CO: function (e) {
        e = _slicedToArray(e, 2);
        return 6022141e13 * (255 * e[0] + e[1]) / 1e21 / 100
    }, HCHO: function (e) {
        var e = _slicedToArray(e, 4), n = e[0];
        return 1e8 * (255 * e[1] * 255 * 255 + 255 * e[2] * 255 + 255 * e[3] + n) / 1e16
    }, NO2TCD: function (e) {
        var e = _slicedToArray(e, 4), n = e[0];
        return +(1e8 * (255 * e[1] * 255 * 255 + 255 * e[2] * 255 + 255 * e[3] + n) / 1e16).toFixed(2)
    }, CH4: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, CO2: function (e) {
        e = _slicedToArray(e, 2);
        return (255 * e[0] + e[1]) / 10
    }, NO2: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, SO2: function (e) {
        e = _slicedToArray(e, 2);
        return (255 * e[0] + e[1]) / 1e3
    }, UVA: function (e) {
        return _slicedToArray(e, 1)[0]
    }, UVB: function (e) {
        return _slicedToArray(e, 1)[0] / 10
    }, UVT: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, TMP: function (e) {
        return _slicedToArray(e, 1)[0] - 128
    }, RH: function (e) {
        return _slicedToArray(e, 1)[0]
    }, PRE: function (e) {
        return _slicedToArray(e, 1)[0]
    }, PRS: function (e) {
        e = _slicedToArray(e, 2);
        return 255 * e[0] + e[1]
    }, VIS: function (e) {
        return 2 * _slicedToArray(e, 1)[0] / 10
    }, AOD: function (e) {
        e = _slicedToArray(e, 2);
        return (255 * e[0] + e[1]) / 1e3
    }
}), hexToRgbArray = function (e) {
    return null == (e = e.replace("#", "").match(/.{2}/g)) ? void 0 : e.map(function (e) {
        return parseInt(e, 16)
    })
}, round = function (e, n) {
    n = Math.pow(10, n || 0);
    return Math.round(e * n) / n
}, isColorDataType = function (e) {
    return "TCOLOR" === e || "DCOLOR" === e
}, getInterpolationColor = function (n, e) {
    var o, t, r, i, a, c, e = e.slice().sort(function (e, n) {
        return (e.min || 0) - (n.min || 0)
    }), u = e.findIndex(function (e) {
        return (e.min || 0 === e.min) && e.max ? n >= e.min && n <= e.max : !e.min && 0 !== e.min || e.max ? !(!e.max || e.min) && n <= e.max : n >= e.min
    });
    return -1 === u ? null : (o = e[u], (e = e[u + 1]) && o.min && null != o && o.max ? (u = (n - o.min) / (o.max - o.min), t = (i = _slicedToArray(hexToRgbArray(o.color), 3))[0], r = i[1], i = i[2], a = (e = _slicedToArray(hexToRgbArray(e.color), 3))[0], c = e[1], e = e[2], [Math.round(t + (a - t) * u), Math.round(r + (c - r) * u), Math.round(i + (e - i) * u)]) : hexToRgbArray(o.color))
}, getTileXyByZoomAndLngLat = function (e, n, o) {
    return [Math.floor((e + 180) / 360 * Math.pow(2, o)), Math.floor((1 - Math.log(Math.tan(n * Math.PI / 180) + 1 / Math.cos(n * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, o))]
}, getTileBoundsByTileXy = function (e, n, o) {
    var t = e / Math.pow(2, o) * 360 - 180, e = (e + 1) / Math.pow(2, o) * 360 - 180,
        r = 180 * Math.atan(Math.sinh(Math.PI * (1 - 2 * n / Math.pow(2, o)))) / Math.PI;
    return [t, 180 * Math.atan(Math.sinh(Math.PI * (1 - 2 * (n + 1) / Math.pow(2, o)))) / Math.PI, e, r]
}, hexColorReg = /^#([0-9a-fA-f]{6})$/, INDEX_DB_NAME = "LEAFLET_RASTER_TILE", WorkerClass = null;
try {
    var WorkerThreads = "undefined" != typeof module && "function" == typeof module.require && module.require("worker_threads") || "function" == typeof __non_webpack_require__ && __non_webpack_require__("worker_threads") || "function" == typeof require && require("worker_threads"),
        WorkerClass = WorkerThreads.Worker
} catch (e) {
}

function decodeBase64$1(e, n) {
    return Buffer.from(e, "base64").toString(n ? "utf16" : "utf8")
}

function createBase64WorkerFactory$2(e, n, o) {
    var n = void 0 === n ? null : n, e = decodeBase64$1(e, void 0 !== o && o), o = e.indexOf("\n", 10) + 1,
        t = e.substring(o) + (n ? "//# sourceMappingURL=" + n : "");
    return function (e) {
        return new WorkerClass(t, Object.assign({}, e, {eval: !0}))
    }
}

function decodeBase64(e, n) {
    var o = atob(e);
    if (n) {
        for (var t = new Uint8Array(o.length), r = 0, i = o.length; r < i; ++r) t[r] = o.charCodeAt(r);
        return String.fromCharCode.apply(null, new Uint16Array(t.buffer))
    }
    return o
}

function createURL(e, n, o) {
    n = void 0 === n ? null : n, e = decodeBase64(e, void 0 !== o && o), o = e.indexOf("\n", 10) + 1, e = e.substring(o) + (n ? "//# sourceMappingURL=" + n : ""), o = new Blob([e], {type: "application/javascript"});
    return URL.createObjectURL(o)
}

function createBase64WorkerFactory$1(n, o, t) {
    var r;
    return function (e) {
        return r = r || createURL(n, o, t), new Worker(r, e)
    }
}

var kIsNodeJS = "[object process]" === Object.prototype.toString.call("undefined" != typeof process ? process : 0);

function isNodeJS() {
    return kIsNodeJS
}

function createBase64WorkerFactory(e, n, o) {
    return (isNodeJS() ? createBase64WorkerFactory$2 : createBase64WorkerFactory$1)(e, n, o)
}

var WorkerFactory = createBase64WorkerFactory("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", null, !1),
    commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function commonjsRequire(e) {
    throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.')
}

var localforageExports = {}, localforage = {
    get exports() {
        return localforageExports
    }, set exports(e) {
        localforageExports = e
    }
}, isRingBbox = (localforage.exports = function t(r, i, a) {
    function c(o, e) {
        if (!i[o]) {
            if (!r[o]) {
                var n = "function" == typeof commonjsRequire && commonjsRequire;
                if (!e && n) return n(o, !0);
                if (u) return u(o, !0);
                e = new Error("Cannot find module '" + o + "'");
                throw e.code = "MODULE_NOT_FOUND", e
            }
            n = i[o] = {exports: {}};
            r[o][0].call(n.exports, function (e) {
                var n = r[o][1][e];
                return c(n || e)
            }, n, n.exports, t, r, i, a)
        }
        return i[o].exports
    }

    for (var u = "function" == typeof commonjsRequire && commonjsRequire, e = 0; e < a.length; e++) c(a[e]);
    return c
}({
    1: [function (e, l, n) {
        !function (n) {
            var e, o, t, r, i = n.MutationObserver || n.WebKitMutationObserver,
                a = i ? (e = 0, i = new i(u), o = n.document.createTextNode(""), i.observe(o, {characterData: !0}), function () {
                    o.data = e = ++e % 2
                }) : n.setImmediate || void 0 === n.MessageChannel ? "document" in n && "onreadystatechange" in n.document.createElement("script") ? function () {
                    var e = n.document.createElement("script");
                    e.onreadystatechange = function () {
                        u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null
                    }, n.document.documentElement.appendChild(e)
                } : function () {
                    setTimeout(u, 0)
                } : ((t = new n.MessageChannel).port1.onmessage = u, function () {
                    t.port2.postMessage(0)
                }), c = [];

            function u() {
                r = !0;
                for (var e, n, o = c.length; o;) {
                    for (n = c, c = [], e = -1; ++e < o;) n[e]();
                    o = c.length
                }
                r = !1
            }

            l.exports = function (e) {
                1 !== c.push(e) || r || a()
            }
        }.call(this, void 0 !== commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
    }, {}], 2: [function (e, n, o) {
        var r = e(1);

        function u() {
        }

        var l = {}, i = ["REJECTED"], a = ["FULFILLED"], t = ["PENDING"];

        function c(e) {
            if ("function" != typeof e) throw new TypeError("resolver must be a function");
            this.state = t, this.queue = [], this.outcome = void 0, e !== u && d(this, e)
        }

        function f(e, n, o) {
            this.promise = e, "function" == typeof n && (this.onFulfilled = n, this.callFulfilled = this.otherCallFulfilled), "function" == typeof o && (this.onRejected = o, this.callRejected = this.otherCallRejected)
        }

        function s(n, o, t) {
            r(function () {
                var e;
                try {
                    e = o(t)
                } catch (e) {
                    return l.reject(n, e)
                }
                e === n ? l.reject(n, new TypeError("Cannot resolve promise with itself")) : l.resolve(n, e)
            })
        }

        function m(e) {
            var n = e && e.then;
            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof n) return function () {
                n.apply(e, arguments)
            }
        }

        function d(n, e) {
            var o = !1;

            function t(e) {
                o || (o = !0, l.reject(n, e))
            }

            function r(e) {
                o || (o = !0, l.resolve(n, e))
            }

            var i = h(function () {
                e(r, t)
            });
            "error" === i.status && t(i.value)
        }

        function h(e, n) {
            var o = {};
            try {
                o.value = e(n), o.status = "success"
            } catch (e) {
                o.status = "error", o.value = e
            }
            return o
        }

        (n.exports = c).prototype.catch = function (e) {
            return this.then(null, e)
        }, c.prototype.then = function (e, n) {
            var o;
            return "function" != typeof e && this.state === a || "function" != typeof n && this.state === i ? this : (o = new this.constructor(u), this.state !== t ? s(o, this.state === a ? e : n, this.outcome) : this.queue.push(new f(o, e, n)), o)
        }, f.prototype.callFulfilled = function (e) {
            l.resolve(this.promise, e)
        }, f.prototype.otherCallFulfilled = function (e) {
            s(this.promise, this.onFulfilled, e)
        }, f.prototype.callRejected = function (e) {
            l.reject(this.promise, e)
        }, f.prototype.otherCallRejected = function (e) {
            s(this.promise, this.onRejected, e)
        }, l.resolve = function (e, n) {
            var o = h(m, n);
            if ("error" === o.status) return l.reject(e, o.value);
            o = o.value;
            if (o) d(e, o); else {
                e.state = a, e.outcome = n;
                for (var t = -1, r = e.queue.length; ++t < r;) e.queue[t].callFulfilled(n)
            }
            return e
        }, l.reject = function (e, n) {
            e.state = i, e.outcome = n;
            for (var o = -1, t = e.queue.length; ++o < t;) e.queue[o].callRejected(n);
            return e
        }, c.resolve = function (e) {
            if (e instanceof this) return e;
            return l.resolve(new this(u), e)
        }, c.reject = function (e) {
            var n = new this(u);
            return l.reject(n, e)
        }, c.all = function (e) {
            var o = this;
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var t = e.length, r = !1;
            if (!t) return this.resolve([]);
            var i = new Array(t), a = 0, n = -1, c = new this(u);
            for (; ++n < t;) !function (e, n) {
                o.resolve(e).then(function (e) {
                    i[n] = e, ++a !== t || r || (r = !0, l.resolve(c, i))
                }, function (e) {
                    r || (r = !0, l.reject(c, e))
                })
            }(e[n], n);
            return c
        }, c.race = function (e) {
            var n = this;
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var o = e.length, t = !1;
            if (!o) return this.resolve([]);
            var r = -1, i = new this(u);
            for (; ++r < o;) !function (e) {
                n.resolve(e).then(function (e) {
                    t || (t = !0, l.resolve(i, e))
                }, function (e) {
                    t || (t = !0, l.reject(i, e))
                })
            }(e[r]);
            return i
        }
    }, {1: 1}], 3: [function (n, e, o) {
        !function (e) {
            "function" != typeof e.Promise && (e.Promise = n(2))
        }.call(this, void 0 !== commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
    }, {2: 2}], 4: [function (e, O, k) {
        var Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e
        } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        };
        var c = function () {
            try {
                return "undefined" != typeof indexedDB ? indexedDB : "undefined" != typeof webkitIndexedDB ? webkitIndexedDB : "undefined" != typeof mozIndexedDB ? mozIndexedDB : "undefined" != typeof OIndexedDB ? OIndexedDB : "undefined" != typeof msIndexedDB ? msIndexedDB : void 0
            } catch (e) {
            }
        }();

        function i(n, o) {
            n = n || [], o = o || {};
            try {
                return new Blob(n, o)
            } catch (e) {
                if ("TypeError" !== e.name) throw e;
                for (var t = new ("undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder), r = 0; r < n.length; r += 1) t.append(n[r]);
                return t.getBlob(o.type)
            }
        }

        "undefined" == typeof Promise && e(3);
        var d = Promise;

        function h(e, n) {
            n && e.then(function (e) {
                n(null, e)
            }, function (e) {
                n(e)
            })
        }

        function u(e, n, o) {
            "function" == typeof n && e.then(n), "function" == typeof o && e.catch(o)
        }

        function f(e) {
            return "string" != typeof e && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e
        }

        function l() {
            if (arguments.length && "function" == typeof arguments[arguments.length - 1]) return arguments[arguments.length - 1]
        }

        var a = "local-forage-detect-blob-support", n = void 0, s = {}, E = Object.prototype.toString, o = "readonly",
            m = "readwrite";

        function K(e) {
            return "boolean" == typeof n ? d.resolve(n) : (t = e, new d(function (o) {
                var e = t.transaction(a, m), n = i([""]);
                e.objectStore(a).put(n, "key"), e.onabort = function (e) {
                    e.preventDefault(), e.stopPropagation(), o(!1)
                }, e.oncomplete = function () {
                    var e = navigator.userAgent.match(/Chrome\/(\d+)/), n = navigator.userAgent.match(/Edge\//);
                    o(n || !e || 43 <= parseInt(e[1], 10))
                }
            }).catch(function () {
                return !1
            }).then(function (e) {
                return n = e
            }));
            var t
        }

        function b(e) {
            var e = s[e.name], o = {};
            o.promise = new d(function (e, n) {
                o.resolve = e, o.reject = n
            }), e.deferredOperations.push(o), e.dbReady ? e.dbReady = e.dbReady.then(function () {
                return o.promise
            }) : e.dbReady = o.promise
        }

        function y(e) {
            e = s[e.name].deferredOperations.pop();
            e && (e.resolve(), e.promise)
        }

        function p(e, n) {
            e = s[e.name].deferredOperations.pop();
            if (e) return e.reject(n), e.promise
        }

        function t(r, i) {
            return new d(function (n, o) {
                if (s[r.name] = s[r.name] || P(), r.db) {
                    if (!i) return n(r.db);
                    b(r), r.db.close()
                }
                var e = [r.name], t = (i && e.push(r.version), c.open.apply(c, e));
                i && (t.onupgradeneeded = function (n) {
                    var e = t.result;
                    try {
                        e.createObjectStore(r.storeName), n.oldVersion <= 1 && e.createObjectStore(a)
                    } catch (e) {
                        if ("ConstraintError" !== e.name) throw e;
                        console.warn('The database "' + r.name + '" has been upgraded from version ' + n.oldVersion + " to version " + n.newVersion + ', but the storage "' + r.storeName + '" already exists.')
                    }
                }), t.onerror = function (e) {
                    e.preventDefault(), o(t.error)
                }, t.onsuccess = function () {
                    var e = t.result;
                    e.onversionchange = function (e) {
                        e.target.close()
                    }, n(e), y(r)
                }
            })
        }

        function v(e) {
            return t(e, !1)
        }

        function g(e) {
            return t(e, !0)
        }

        function x(e, n) {
            var o, t, r;
            return !e.db || (o = !e.db.objectStoreNames.contains(e.storeName), r = e.version < e.db.version, t = e.version > e.db.version, r && (e.version !== n && console.warn('The database "' + e.name + "\" can't be downgraded from version " + e.db.version + " to version " + e.version + "."), e.version = e.db.version), (t || o) && (o && (r = e.db.version + 1) > e.version && (e.version = r), 1))
        }

        function D(e) {
            return i([function (e) {
                for (var n = e.length, o = new ArrayBuffer(n), t = new Uint8Array(o), r = 0; r < n; r++) t[r] = e.charCodeAt(r);
                return o
            }(atob(e.data))], {type: e.type})
        }

        function G(e) {
            return e && e.__local_forage_encoded_blob
        }

        function F(e) {
            var n = this, o = n._initReady().then(function () {
                var e = s[n._dbInfo.name];
                if (e && e.dbReady) return e.dbReady
            });
            return u(o, e, e), o
        }

        function _(n, o, t, r) {
            void 0 === r && (r = 1);
            try {
                var e = n.db.transaction(n.storeName, o);
                t(null, e)
            } catch (e) {
                if (0 < r && (!n.db || "InvalidStateError" === e.name || "NotFoundError" === e.name)) return d.resolve().then(function () {
                    if (!n.db || "NotFoundError" === e.name && !n.db.objectStoreNames.contains(n.storeName) && n.version <= n.db.version) return n.db && (n.version = n.db.version + 1), g(n)
                }).then(function () {
                    return function (o) {
                        b(o);
                        for (var t = s[o.name], r = t.forages, e = 0; e < r.length; e++) {
                            var n = r[e];
                            n._dbInfo.db && (n._dbInfo.db.close(), n._dbInfo.db = null)
                        }
                        return o.db = null, v(o).then(function (e) {
                            return o.db = e, x(o) ? g(o) : e
                        }).then(function (e) {
                            o.db = t.db = e;
                            for (var n = 0; n < r.length; n++) r[n]._dbInfo.db = e
                        }).catch(function (e) {
                            throw p(o, e), e
                        })
                    }(n).then(function () {
                        _(n, o, t, r - 1)
                    })
                }).catch(t);
                t(e)
            }
        }

        function P() {
            return {forages: [], db: null, dbReady: null, deferredOperations: []}
        }

        e = {
            _driver: "asyncStorage", _initStorage: function (e) {
                var t = this, r = {db: null};
                if (e) for (var n in e) r[n] = e[n];
                var i = s[r.name],
                    o = (i || (i = P(), s[r.name] = i), i.forages.push(t), t._initReady || (t._initReady = t.ready, t.ready = F), []);

                function a() {
                    return d.resolve()
                }

                for (var c = 0; c < i.forages.length; c++) {
                    var u = i.forages[c];
                    u !== t && o.push(u._initReady().catch(a))
                }
                var l = i.forages.slice(0);
                return d.all(o).then(function () {
                    return r.db = i.db, v(r)
                }).then(function (e) {
                    return r.db = e, x(r, t._defaultConfig.version) ? g(r) : e
                }).then(function (e) {
                    r.db = i.db = e, t._dbInfo = r;
                    for (var n = 0; n < l.length; n++) {
                        var o = l[n];
                        o !== t && (o._dbInfo.db = r.db, o._dbInfo.version = r.version)
                    }
                })
            }, _support: function () {
                try {
                    var e, n;
                    return c && c.open ? (e = "undefined" != typeof openDatabase && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), n = "function" == typeof fetch && -1 !== fetch.toString().indexOf("[native code"), (!e || n) && "undefined" != typeof indexedDB && "undefined" != typeof IDBKeyRange) : !1
                } catch (e) {
                    return !1
                }
            }(), iterate: function (a, e) {
                var c = this, n = new d(function (r, i) {
                    c.ready().then(function () {
                        _(c._dbInfo, o, function (e, n) {
                            if (e) return i(e);
                            try {
                                var o = n.objectStore(c._dbInfo.storeName).openCursor(), t = 1;
                                o.onsuccess = function () {
                                    var e, n = o.result;
                                    n ? (G(e = n.value) && (e = D(e)), void 0 !== (e = a(e, n.key, t++)) ? r(e) : n.continue()) : r()
                                }, o.onerror = function () {
                                    i(o.error)
                                }
                            } catch (e) {
                                i(e)
                            }
                        })
                    }).catch(i)
                });
                return h(n, e), n
            }, getItem: function (i, e) {
                var a = this, n = (i = f(i), new d(function (t, r) {
                    a.ready().then(function () {
                        _(a._dbInfo, o, function (e, n) {
                            if (e) return r(e);
                            try {
                                var o = n.objectStore(a._dbInfo.storeName).get(i);
                                o.onsuccess = function () {
                                    var e = o.result;
                                    G(e = void 0 === e ? null : e) && (e = D(e)), t(e)
                                }, o.onerror = function () {
                                    r(o.error)
                                }
                            } catch (e) {
                                r(e)
                            }
                        })
                    }).catch(r)
                }));
                return h(n, e), n
            }, setItem: function (c, n, e) {
                var u = this, o = (c = f(c), new d(function (i, a) {
                    var e;
                    u.ready().then(function () {
                        return e = u._dbInfo, "[object Blob]" === E.call(n) ? K(e.db).then(function (e) {
                            return e ? n : (t = n, new d(function (n, e) {
                                var o = new FileReader;
                                o.onerror = e, o.onloadend = function (e) {
                                    e = btoa(e.target.result || "");
                                    n({__local_forage_encoded_blob: !0, data: e, type: t.type})
                                }, o.readAsBinaryString(t)
                            }));
                            var t
                        }) : n
                    }).then(function (r) {
                        _(u._dbInfo, m, function (e, n) {
                            if (e) return a(e);
                            try {
                                var o = n.objectStore(u._dbInfo.storeName),
                                    t = (null === r && (r = void 0), o.put(r, c));
                                n.oncomplete = function () {
                                    i(r = void 0 === r ? null : r)
                                }, n.onabort = n.onerror = function () {
                                    var e = t.error || t.transaction.error;
                                    a(e)
                                }
                            } catch (e) {
                                a(e)
                            }
                        })
                    }).catch(a)
                }));
                return h(o, e), o
            }, removeItem: function (i, e) {
                var a = this, n = (i = f(i), new d(function (t, r) {
                    a.ready().then(function () {
                        _(a._dbInfo, m, function (e, n) {
                            if (e) return r(e);
                            try {
                                var o = n.objectStore(a._dbInfo.storeName).delete(i);
                                n.oncomplete = function () {
                                    t()
                                }, n.onerror = function () {
                                    r(o.error)
                                }, n.onabort = function () {
                                    var e = o.error || o.transaction.error;
                                    r(e)
                                }
                            } catch (e) {
                                r(e)
                            }
                        })
                    }).catch(r)
                }));
                return h(n, e), n
            }, clear: function (e) {
                var i = this, n = new d(function (t, r) {
                    i.ready().then(function () {
                        _(i._dbInfo, m, function (e, n) {
                            if (e) return r(e);
                            try {
                                var o = n.objectStore(i._dbInfo.storeName).clear();
                                n.oncomplete = function () {
                                    t()
                                }, n.onabort = n.onerror = function () {
                                    var e = o.error || o.transaction.error;
                                    r(e)
                                }
                            } catch (e) {
                                r(e)
                            }
                        })
                    }).catch(r)
                });
                return h(n, e), n
            }, length: function (e) {
                var i = this, n = new d(function (t, r) {
                    i.ready().then(function () {
                        _(i._dbInfo, o, function (e, n) {
                            if (e) return r(e);
                            try {
                                var o = n.objectStore(i._dbInfo.storeName).count();
                                o.onsuccess = function () {
                                    t(o.result)
                                }, o.onerror = function () {
                                    r(o.error)
                                }
                            } catch (e) {
                                r(e)
                            }
                        })
                    }).catch(r)
                });
                return h(n, e), n
            }, key: function (c, e) {
                var u = this, n = new d(function (i, a) {
                    c < 0 ? i(null) : u.ready().then(function () {
                        _(u._dbInfo, o, function (e, n) {
                            if (e) return a(e);
                            try {
                                var o = n.objectStore(u._dbInfo.storeName), t = !1, r = o.openKeyCursor();
                                r.onsuccess = function () {
                                    var e = r.result;
                                    e ? 0 === c || t ? i(e.key) : (t = !0, e.advance(c)) : i(null)
                                }, r.onerror = function () {
                                    a(r.error)
                                }
                            } catch (e) {
                                a(e)
                            }
                        })
                    }).catch(a)
                });
                return h(n, e), n
            }, keys: function (e) {
                var a = this, n = new d(function (r, i) {
                    a.ready().then(function () {
                        _(a._dbInfo, o, function (e, n) {
                            if (e) return i(e);
                            try {
                                var o = n.objectStore(a._dbInfo.storeName).openKeyCursor(), t = [];
                                o.onsuccess = function () {
                                    var e = o.result;
                                    e ? (t.push(e.key), e.continue()) : r(t)
                                }, o.onerror = function () {
                                    i(o.error)
                                }
                            } catch (e) {
                                i(e)
                            }
                        })
                    }).catch(i)
                });
                return h(n, e), n
            }, dropInstance: function (a, e) {
                e = l.apply(this, arguments);
                var n = this.config();
                return (a = "function" != typeof a && a || {}).name || (a.name = a.name || n.name, a.storeName = a.storeName || n.storeName), h(n = a.name ? (n = a.name === n.name && this._dbInfo.db ? d.resolve(this._dbInfo.db) : v(a).then(function (e) {
                    var n = s[a.name], o = n.forages;
                    n.db = e;
                    for (var t = 0; t < o.length; t++) o[t]._dbInfo.db = e;
                    return e
                }), a.storeName ? n.then(function (e) {
                    if (e.objectStoreNames.contains(a.storeName)) {
                        var r = e.version + 1, t = (b(a), s[a.name]), i = t.forages;
                        e.close();
                        for (var n = 0; n < i.length; n++) {
                            var o = i[n];
                            o._dbInfo.db = null, o._dbInfo.version = r
                        }
                        return new d(function (n, o) {
                            var t = c.open(a.name, r);
                            t.onerror = function (e) {
                                t.result.close(), o(e)
                            }, t.onupgradeneeded = function () {
                                t.result.deleteObjectStore(a.storeName)
                            }, t.onsuccess = function () {
                                var e = t.result;
                                e.close(), n(e)
                            }
                        }).then(function (e) {
                            t.db = e;
                            for (var n = 0; n < i.length; n++) {
                                var o = i[n];
                                o._dbInfo.db = e, y(o._dbInfo)
                            }
                        }).catch(function (e) {
                            throw(p(a, e) || d.resolve()).catch(function () {
                            }), e
                        })
                    }
                }) : n.then(function (e) {
                    b(a);
                    var o = s[a.name], t = o.forages;
                    e.close();
                    for (var n = 0; n < t.length; n++) t[n]._dbInfo.db = null;
                    return new d(function (n, o) {
                        var t = c.deleteDatabase(a.name);
                        t.onerror = function () {
                            var e = t.result;
                            e && e.close(), o(t.error)
                        }, t.onblocked = function () {
                            console.warn('dropInstance blocked for database "' + a.name + '" until all open connections are closed')
                        }, t.onsuccess = function () {
                            var e = t.result;
                            e && e.close(), n(e)
                        }
                    }).then(function (e) {
                        o.db = e;
                        for (var n = 0; n < t.length; n++) y(t[n]._dbInfo)
                    }).catch(function (e) {
                        throw(p(a, e) || d.resolve()).catch(function () {
                        }), e
                    })
                })) : d.reject("Invalid arguments"), e), n
            }
        };
        var I = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", V = /^~~local_forage_type~([^~]+)~/,
            w = "__lfsc__:", S = w.length, T = "arbf", A = "blob", z = S + T.length, U = Object.prototype.toString;

        function H(e) {
            for (var n, o, t, r, i = .75 * e.length, a = e.length, c = 0, i = ("=" === e[e.length - 1] && (i--, "=" === e[e.length - 2]) && i--, new ArrayBuffer(i)), u = new Uint8Array(i), l = 0; l < a; l += 4) n = I.indexOf(e[l]), o = I.indexOf(e[l + 1]), t = I.indexOf(e[l + 2]), r = I.indexOf(e[l + 3]), u[c++] = n << 2 | o >> 4, u[c++] = (15 & o) << 4 | t >> 2, u[c++] = (3 & t) << 6 | 63 & r;
            return i
        }

        function W(e) {
            for (var n = new Uint8Array(e), o = "", t = 0; t < n.length; t += 3) o = (o = (o = (o += I[n[t] >> 2]) + I[(3 & n[t]) << 4 | n[t + 1] >> 4]) + I[(15 & n[t + 1]) << 2 | n[t + 2] >> 6]) + I[63 & n[t + 2]];
            return n.length % 3 == 2 ? o = o.substring(0, o.length - 1) + "=" : n.length % 3 == 1 && (o = o.substring(0, o.length - 2) + "=="), o
        }

        var C = {
            serialize: function (n, o) {
                var e = "";
                if (n && (e = U.call(n)), n && ("[object ArrayBuffer]" === e || n.buffer && "[object ArrayBuffer]" === U.call(n.buffer))) {
                    var t, r = w;
                    n instanceof ArrayBuffer ? (t = n, r += T) : (t = n.buffer, "[object Int8Array]" === e ? r += "si08" : "[object Uint8Array]" === e ? r += "ui08" : "[object Uint8ClampedArray]" === e ? r += "uic8" : "[object Int16Array]" === e ? r += "si16" : "[object Uint16Array]" === e ? r += "ur16" : "[object Int32Array]" === e ? r += "si32" : "[object Uint32Array]" === e ? r += "ui32" : "[object Float32Array]" === e ? r += "fl32" : "[object Float64Array]" === e ? r += "fl64" : o(new Error("Failed to get type for BinaryArray"))), o(r + W(t))
                } else if ("[object Blob]" === e) {
                    r = new FileReader;
                    r.onload = function () {
                        var e = "~~local_forage_type~" + n.type + "~" + W(this.result);
                        o(w + A + e)
                    }, r.readAsArrayBuffer(n)
                } else try {
                    o(JSON.stringify(n))
                } catch (e) {
                    console.error("Couldn't convert value into a JSON string: ", n), o(null, e)
                }
            }, deserialize: function (e) {
                if (e.substring(0, S) !== w) return JSON.parse(e);
                var n, o = e.substring(z), t = e.substring(S, z),
                    r = (t === A && V.test(o) && (n = (e = o.match(V))[1], o = o.substring(e[0].length)), H(o));
                switch (t) {
                    case T:
                        return r;
                    case A:
                        return i([r], {type: n});
                    case"si08":
                        return new Int8Array(r);
                    case"ui08":
                        return new Uint8Array(r);
                    case"uic8":
                        return new Uint8ClampedArray(r);
                    case"si16":
                        return new Int16Array(r);
                    case"ur16":
                        return new Uint16Array(r);
                    case"si32":
                        return new Int32Array(r);
                    case"ui32":
                        return new Uint32Array(r);
                    case"fl32":
                        return new Float32Array(r);
                    case"fl64":
                        return new Float64Array(r);
                    default:
                        throw new Error("Unkown type: " + t)
                }
            }, stringToBuffer: H, bufferToString: W
        };

        function Y(e, n, o, t) {
            e.executeSql("CREATE TABLE IF NOT EXISTS " + n.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], o, t)
        }

        function R(e, t, r, i, a, c) {
            e.executeSql(r, i, a, function (e, o) {
                o.code === o.SYNTAX_ERR ? e.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [t.storeName], function (e, n) {
                    n.rows.length ? c(e, o) : Y(e, t, function () {
                        e.executeSql(r, i, a, c)
                    }, c)
                }, c) : c(e, o)
            }, c)
        }

        function J(a, e, c, u) {
            var l = this, n = (a = f(a), new d(function (r, i) {
                l.ready().then(function () {
                    var o = e = void 0 === e ? null : e, t = l._dbInfo;
                    t.serializer.serialize(e, function (n, e) {
                        e ? i(e) : t.db.transaction(function (e) {
                            R(e, t, "INSERT OR REPLACE INTO " + t.storeName + " (key, value) VALUES (?, ?)", [a, n], function () {
                                r(o)
                            }, function (e, n) {
                                i(n)
                            })
                        }, function (e) {
                            e.code === e.QUOTA_ERR && (0 < u ? r(J.apply(l, [a, o, c, u - 1])) : i(e))
                        })
                    })
                }).catch(i)
            }));
            return h(n, c), n
        }

        var r = {
            _driver: "webSQLStorage", _initStorage: function (e) {
                var t = this, r = {db: null};
                if (e) for (var n in e) r[n] = "string" != typeof e[n] ? e[n].toString() : e[n];
                var o = new d(function (n, o) {
                    try {
                        r.db = openDatabase(r.name, String(r.version), r.description, r.size)
                    } catch (e) {
                        return o(e)
                    }
                    r.db.transaction(function (e) {
                        Y(e, r, function () {
                            t._dbInfo = r, n()
                        }, function (e, n) {
                            o(n)
                        })
                    }, o)
                });
                return r.serializer = C, o
            }, _support: "function" == typeof openDatabase, iterate: function (l, e) {
                var n = this, o = new d(function (u, o) {
                    n.ready().then(function () {
                        var c = n._dbInfo;
                        c.db.transaction(function (e) {
                            R(e, c, "SELECT * FROM " + c.storeName, [], function (e, n) {
                                for (var o = n.rows, t = o.length, r = 0; r < t; r++) {
                                    var i = o.item(r), a = (a = i.value) && c.serializer.deserialize(a);
                                    if (void 0 !== (a = l(a, i.key, r + 1))) return void u(a)
                                }
                                u()
                            }, function (e, n) {
                                o(n)
                            })
                        })
                    }).catch(o)
                });
                return h(o, e), o
            }, getItem: function (n, e) {
                var i = this, o = (n = f(n), new d(function (t, r) {
                    i.ready().then(function () {
                        var o = i._dbInfo;
                        o.db.transaction(function (e) {
                            R(e, o, "SELECT * FROM " + o.storeName + " WHERE key = ? LIMIT 1", [n], function (e, n) {
                                n = (n = n.rows.length ? n.rows.item(0).value : null) && o.serializer.deserialize(n);
                                t(n)
                            }, function (e, n) {
                                r(n)
                            })
                        })
                    }).catch(r)
                }));
                return h(o, e), o
            }, setItem: function (e, n, o) {
                return J.apply(this, [e, n, o, 1])
            }, removeItem: function (r, e) {
                var i = this, n = (r = f(r), new d(function (o, t) {
                    i.ready().then(function () {
                        var n = i._dbInfo;
                        n.db.transaction(function (e) {
                            R(e, n, "DELETE FROM " + n.storeName + " WHERE key = ?", [r], function () {
                                o()
                            }, function (e, n) {
                                t(n)
                            })
                        })
                    }).catch(t)
                }));
                return h(n, e), n
            }, clear: function (e) {
                var r = this, n = new d(function (o, t) {
                    r.ready().then(function () {
                        var n = r._dbInfo;
                        n.db.transaction(function (e) {
                            R(e, n, "DELETE FROM " + n.storeName, [], function () {
                                o()
                            }, function (e, n) {
                                t(n)
                            })
                        })
                    }).catch(t)
                });
                return h(n, e), n
            }, length: function (e) {
                var r = this, n = new d(function (o, t) {
                    r.ready().then(function () {
                        var n = r._dbInfo;
                        n.db.transaction(function (e) {
                            R(e, n, "SELECT COUNT(key) as c FROM " + n.storeName, [], function (e, n) {
                                n = n.rows.item(0).c;
                                o(n)
                            }, function (e, n) {
                                t(n)
                            })
                        })
                    }).catch(t)
                });
                return h(n, e), n
            }, key: function (r, e) {
                var i = this, n = new d(function (o, t) {
                    i.ready().then(function () {
                        var n = i._dbInfo;
                        n.db.transaction(function (e) {
                            R(e, n, "SELECT key FROM " + n.storeName + " WHERE id = ? LIMIT 1", [r + 1], function (e, n) {
                                n = n.rows.length ? n.rows.item(0).key : null;
                                o(n)
                            }, function (e, n) {
                                t(n)
                            })
                        })
                    }).catch(t)
                });
                return h(n, e), n
            }, keys: function (e) {
                var t = this, n = new d(function (r, o) {
                    t.ready().then(function () {
                        var n = t._dbInfo;
                        n.db.transaction(function (e) {
                            R(e, n, "SELECT key FROM " + n.storeName, [], function (e, n) {
                                for (var o = [], t = 0; t < n.rows.length; t++) o.push(n.rows.item(t).key);
                                r(o)
                            }, function (e, n) {
                                o(n)
                            })
                        })
                    }).catch(o)
                });
                return h(n, e), n
            }, dropInstance: function (o, e) {
                e = l.apply(this, arguments);
                var t = this.config(),
                    r = ((o = "function" != typeof o && o || {}).name || (o.name = o.name || t.name, o.storeName = o.storeName || t.storeName), this),
                    n = o.name ? new d(function (e) {
                        var i, n = o.name === t.name ? r._dbInfo.db : openDatabase(o.name, "", "", 0);
                        o.storeName ? e({db: n, storeNames: [o.storeName]}) : e((i = n, new d(function (r, o) {
                            i.transaction(function (e) {
                                e.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (e, n) {
                                    for (var o = [], t = 0; t < n.rows.length; t++) o.push(n.rows.item(t).name);
                                    r({db: i, storeNames: o})
                                }, function (e, n) {
                                    o(n)
                                })
                            }, function (e) {
                                o(e)
                            })
                        })))
                    }).then(function (a) {
                        return new d(function (r, i) {
                            a.db.transaction(function (t) {
                                for (var e = [], n = 0, o = a.storeNames.length; n < o; n++) e.push(function (n) {
                                    return new d(function (e, o) {
                                        t.executeSql("DROP TABLE IF EXISTS " + n, [], function () {
                                            e()
                                        }, function (e, n) {
                                            o(n)
                                        })
                                    })
                                }(a.storeNames[n]));
                                d.all(e).then(function () {
                                    r()
                                }).catch(function (e) {
                                    i(e)
                                })
                            }, function (e) {
                                i(e)
                            })
                        })
                    }) : d.reject("Invalid arguments");
                return h(n, e), n
            }
        };

        function Q(e, n) {
            var o = e.name + "/";
            return e.storeName !== n.storeName && (o += e.storeName + "/"), o
        }

        function q() {
            return !function () {
                var e = "_localforage_support_test";
                try {
                    localStorage.setItem(e, !0), localStorage.removeItem(e)
                } catch (e) {
                    return 1
                }
            }() || 0 < localStorage.length
        }

        function $(e, n) {
            for (var o, t, r = e.length, i = 0; i < r;) {
                if ((o = e[i]) === (t = n) || "number" == typeof o && "number" == typeof t && isNaN(o) && isNaN(t)) return 1;
                i++
            }
        }

        var ee = {
                _driver: "localStorageWrapper", _initStorage: function (e) {
                    var n = {};
                    if (e) for (var o in e) n[o] = e[o];
                    return n.keyPrefix = Q(e, this._defaultConfig), q() ? ((this._dbInfo = n).serializer = C, d.resolve()) : d.reject()
                }, _support: function () {
                    try {
                        return "undefined" != typeof localStorage && "setItem" in localStorage && !!localStorage.setItem
                    } catch (e) {
                        return !1
                    }
                }(), iterate: function (u, e) {
                    var l = this, n = l.ready().then(function () {
                        for (var e = l._dbInfo, n = e.keyPrefix, o = n.length, t = localStorage.length, r = 1, i = 0; i < t; i++) {
                            var a = localStorage.key(i);
                            if (0 === a.indexOf(n)) {
                                var c = (c = localStorage.getItem(a)) && e.serializer.deserialize(c);
                                if (void 0 !== (c = u(c, a.substring(o), r++))) return c
                            }
                        }
                    });
                    return h(n, e), n
                }, getItem: function (o, e) {
                    var t = this, n = (o = f(o), t.ready().then(function () {
                        var e = t._dbInfo, n = localStorage.getItem(e.keyPrefix + o);
                        return n = n && e.serializer.deserialize(n)
                    }));
                    return h(n, e), n
                }, setItem: function (a, e, n) {
                    var c = this, o = (a = f(a), c.ready().then(function () {
                        var i = e = void 0 === e ? null : e;
                        return new d(function (o, t) {
                            var r = c._dbInfo;
                            r.serializer.serialize(e, function (e, n) {
                                if (n) t(n); else try {
                                    localStorage.setItem(r.keyPrefix + a, e), o(i)
                                } catch (e) {
                                    "QuotaExceededError" !== e.name && "NS_ERROR_DOM_QUOTA_REACHED" !== e.name || t(e), t(e)
                                }
                            })
                        })
                    }));
                    return h(o, n), o
                }, removeItem: function (n, e) {
                    var o = this, t = (n = f(n), o.ready().then(function () {
                        var e = o._dbInfo;
                        localStorage.removeItem(e.keyPrefix + n)
                    }));
                    return h(t, e), t
                }, clear: function (e) {
                    var t = this, n = t.ready().then(function () {
                        for (var e = t._dbInfo.keyPrefix, n = localStorage.length - 1; 0 <= n; n--) {
                            var o = localStorage.key(n);
                            0 === o.indexOf(e) && localStorage.removeItem(o)
                        }
                    });
                    return h(n, e), n
                }, length: function (e) {
                    var n = this.keys().then(function (e) {
                        return e.length
                    });
                    return h(n, e), n
                }, key: function (o, e) {
                    var t = this, n = t.ready().then(function () {
                        var n, e = t._dbInfo;
                        try {
                            n = localStorage.key(o)
                        } catch (e) {
                            n = null
                        }
                        return n = n && n.substring(e.keyPrefix.length)
                    });
                    return h(n, e), n
                }, keys: function (e) {
                    var i = this, n = i.ready().then(function () {
                        for (var e = i._dbInfo, n = localStorage.length, o = [], t = 0; t < n; t++) {
                            var r = localStorage.key(t);
                            0 === r.indexOf(e.keyPrefix) && o.push(r.substring(e.keyPrefix.length))
                        }
                        return o
                    });
                    return h(n, e), n
                }, dropInstance: function (n, e) {
                    e = l.apply(this, arguments), (n = "function" != typeof n && n || {}).name || (t = this.config(), n.name = n.name || t.name, n.storeName = n.storeName || t.storeName);
                    var o = this, t = n.name ? new d(function (e) {
                        n.storeName ? e(Q(n, o._defaultConfig)) : e(n.name + "/")
                    }).then(function (e) {
                        for (var n = localStorage.length - 1; 0 <= n; n--) {
                            var o = localStorage.key(n);
                            0 === o.indexOf(e) && localStorage.removeItem(o)
                        }
                    }) : d.reject("Invalid arguments");
                    return h(t, e), t
                }
            }, ne = Array.isArray || function (e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            }, L = {}, oe = {}, j = {INDEXEDDB: e, WEBSQL: r, LOCALSTORAGE: ee},
            e = [j.INDEXEDDB._driver, j.WEBSQL._driver, j.LOCALSTORAGE._driver], N = ["dropInstance"],
            X = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(N), te = {
                description: "",
                driver: e.slice(),
                name: "localforage",
                size: 4980736,
                storeName: "keyvaluepairs",
                version: 1
            };

        function B(e) {
            for (var n = 1; n < arguments.length; n++) {
                var o = arguments[n];
                if (o) for (var t in o) o.hasOwnProperty(t) && (ne(o[t]) ? e[t] = o[t].slice() : e[t] = o[t])
            }
            return e
        }

        function M(e) {
            var n, o, t;
            if (!(this instanceof M)) throw new TypeError("Cannot call a class as a function");
            for (n in j) j.hasOwnProperty(n) && (t = (o = j[n])._driver, this[n] = t, L[t] || this.defineDriver(o));
            this._defaultConfig = B({}, te), this._config = B({}, this._defaultConfig, e), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function () {
            })
        }

        M.prototype.config = function (e) {
            if ("object" !== (void 0 === e ? "undefined" : Z(e))) return "string" == typeof e ? this._config[e] : this._config;
            if (this._ready) return new Error("Can't call config() after localforage has been used.");
            for (var n in e) {
                if ("storeName" === n && (e[n] = e[n].replace(/\W/g, "_")), "version" === n && "number" != typeof e[n]) return new Error("Database version must be a number.");
                this._config[n] = e[n]
            }
            return !("driver" in e && e.driver) || this.setDriver(this._config.driver)
        }, M.prototype.defineDriver = function (m, e, n) {
            var o = new d(function (n, o) {
                try {
                    var t = m._driver,
                        e = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                    if (m._driver) {
                        for (var r = X.concat("_initStorage"), i = 0, a = r.length; i < a; i++) {
                            var c = r[i];
                            if ((!$(N, c) || m[c]) && "function" != typeof m[c]) return void o(e)
                        }
                        for (var u = 0, l = N.length; u < l; u++) {
                            var f = N[u];
                            m[f] || (m[f] = function (n) {
                                return function () {
                                    var e = new Error("Method " + n + " is not implemented by the current driver"),
                                        e = d.reject(e);
                                    return h(e, arguments[arguments.length - 1]), e
                                }
                            }(f))
                        }

                        function s(e) {
                            L[t] && console.info("Redefining LocalForage driver: " + t), L[t] = m, oe[t] = e, n()
                        }

                        "_support" in m ? m._support && "function" == typeof m._support ? m._support().then(s, o) : s(!!m._support) : s(!0)
                    } else o(e)
                } catch (e) {
                    o(e)
                }
            });
            return u(o, e, n), o
        }, M.prototype.driver = function () {
            return this._driver || null
        }, M.prototype.getDriver = function (e, n, o) {
            e = L[e] ? d.resolve(L[e]) : d.reject(new Error("Driver not found."));
            return u(e, n, o), e
        }, M.prototype.getSerializer = function (e) {
            var n = d.resolve(C);
            return u(n, e), n
        }, M.prototype.ready = function (e) {
            var n = this, o = n._driverSet.then(function () {
                return null === n._ready && (n._ready = n._initDriver()), n._ready
            });
            return u(o, e, e), o
        }, M.prototype.setDriver = function (e, n, o) {
            var i = this, t = (ne(e) || (e = [e]), this._getSupportedDrivers(e));

            function a() {
                i._config.driver = i.driver()
            }

            function c(e) {
                return i._extend(e), a(), i._ready = i._initStorage(i._config), i._ready
            }

            function r(r) {
                return function () {
                    var t = 0;
                    return function e() {
                        for (; t < r.length;) {
                            var n = r[t];
                            return t++, i._dbInfo = null, i._ready = null, i.getDriver(n).then(c).catch(e)
                        }
                        a();
                        var o = new Error("No available storage method found.");
                        return i._driverSet = d.reject(o), i._driverSet
                    }()
                }
            }

            e = null !== this._driverSet ? this._driverSet.catch(function () {
                return d.resolve()
            }) : d.resolve();
            return this._driverSet = e.then(function () {
                var e = t[0];
                return i._dbInfo = null, i._ready = null, i.getDriver(e).then(function (e) {
                    i._driver = e._driver, a(), i._wrapLibraryMethodsWithReady(), i._initDriver = r(t)
                })
            }).catch(function () {
                a();
                var e = new Error("No available storage method found.");
                return i._driverSet = d.reject(e), i._driverSet
            }), u(this._driverSet, n, o), this._driverSet
        }, M.prototype.supports = function (e) {
            return !!oe[e]
        }, M.prototype._extend = function (e) {
            B(this, e)
        }, M.prototype._getSupportedDrivers = function (e) {
            for (var n = [], o = 0, t = e.length; o < t; o++) {
                var r = e[o];
                this.supports(r) && n.push(r)
            }
            return n
        }, M.prototype._wrapLibraryMethodsWithReady = function () {
            for (var e = 0, n = X.length; e < n; e++) !function (n, o) {
                n[o] = function () {
                    var e = arguments;
                    return n.ready().then(function () {
                        return n[o].apply(n, e)
                    })
                }
            }(this, X[e])
        }, M.prototype.createInstance = function (e) {
            return new M(e)
        };
        r = new M;
        O.exports = r
    }, {3: 3}]
}, {}, [4])(4), localforageExports.config({name: INDEX_DB_NAME}), function (e, n) {
    if (4 !== e.length) return !1;
    for (var o = 0, t = 0, r = 0; r < 4; r++) {
        if (e[r].x !== n.min.x && e[r].x !== n.max.x || e[r].y !== n.min.y && e[r].y !== n.max.y) return !1;
        o += e[r].x, t += e[r].y
    }
    return o === 2 * (n.min.x + n.max.x) && t === 2 * (n.min.y + n.max.y)
}), ExtendMethods = {
    _toMercGeometry: function (e) {
        for (var n = [], o = 0; o < e.length; o++) {
            var t = e[o].getLatLngs();
            t[0] instanceof Array ? t[0][0] instanceof Array || (t = [t]) : t = [[t]], n = n.concat(t)
        }
        for (var r = [], i = 0; i < n.length; i++) {
            for (var a = [], c = 0; c < n[i].length; c++) {
                for (var u = [], l = 0; l < n[i][c].length; l++) u.push(this._map.project(n[i][c][l], 0));
                a.push(u)
            }
            r.push(a)
        }
        return r
    }, _getOriginalMercBoundary: function () {
        var e, n;
        if (!this._mercBoundary) for (this._mercBoundary = this._toMercGeometry(this.options.polygons), this._mercBbox = new L.Bounds, n = 0; n < this._mercBoundary.length; n++) e = new L.Bounds(this._mercBoundary[n][0]), this._mercBbox.extend(e.min), this._mercBbox.extend(e.max);
        return this._mercBoundary
    }, _getClippedGeometry: function (e, n) {
        for (var o, t, r, i, a = [], c = 0; c < e.length; c++) if (o = [], 0 !== (t = L.PolyUtil.clipPolygon(e[c][0], n)).length) {
            for (o.push(t), i = 1; i < e[c].length; i++) 0 < (r = L.PolyUtil.clipPolygon(e[c][i], n)).length && o.push(r);
            a.push(o)
        }
        if (0 !== a.length) for (c = 0; c < a.length; c++) {
            if (!isRingBbox(a[c][0], n)) return {geometry: a};
            if (1 === a[c].length) return {isIn: !0};
            for (i = 1; i < a[c].length; i++) if (!isRingBbox(a[c][i], n)) return {geometry: a}
        }
        return {isOut: !0}
    }, _getTileGeometry: function (e, n, o, t) {
        if (!this.options.polygons) return {isIn: !0};
        var r = e + ":" + n + ":" + o, i = Math.pow(2, o - this.options.zoomOffset), a = this._boundaryCache,
            c = this._getOriginalMercBoundary(), u = this.options.tileSize,
            u = new L.Bounds(new L.Point(e * u / i, n * u / i), new L.Point((e + 1) * u / i, (n + 1) * u / i));
        if (!t && !u.intersects(this._mercBbox)) return {isOut: !0};
        if (0 === o) a[r] = {geometry: c}; else {
            if ((i = this._getTileGeometry(Math.floor(e / 2), Math.floor(n / 2), o - 1, !0)).isOut || i.isIn) return i;
            a[r] = this._getClippedGeometry(c, u)
        }
        return a[r]
    }, _coloring: function (e, n, o) {
        for (var t = 0; t < o.data.length; t += 4) {
            var r, i = o.data[t], a = o.data[t + 1], c = o.data[t + 2], u = o.data[t + 3];
            u = (0 !== i || 0 !== a || 0 !== c) && (r = decoders[e]([i, a, c, u]), r = getInterpolationColor(r, n)) ? (i = (r = _slicedToArray(r, 3))[0], a = r[1], c = r[2], 255) : 0, o.data[t] = i, o.data[t + 1] = a, o.data[t + 2] = c, o.data[t + 3] = u
        }
        return o
    }, _createCacheKey: function (e) {
        var n = e.x, o = e.y, e = e.z, t = this.options, r = t.type, i = t.agg, a = t.token, t = t.time;
        return JSON.stringify([r, i, a, t, n, o, e])
    }, _drawTileInternal: function (f, s, m, d) {
        var h, b, y, p, v, e, g = this._getZoomForUrl(), x = this._getTileGeometry(s.x, s.y, g);
        "show" == this.options.mode && null == x.isIn && null == x.geometry || "clip" == this.options.mode && null == x.isOut && null == x.geometry ? d() : (h = this.options.tileSize, b = h * s.x, y = h * s.y, p = Math.pow(2, g - this.options.zoomOffset), v = f.getContext("2d"), (image = new Image).crossOrigin = "Anonymous", f.complete = !0, e = function () {
            var e, n, o, t, r, i = this;
            if (x.geometry) {
                for (r = x.geometry, v.beginPath(), e = 0; e < r.length; e++) for (n = 0; n < r[e].length; n++) if (0 !== r[e][n].length) for (v.moveTo(r[e][n][0].x * p - b, r[e][n][0].y * p - y), o = 1; o < r[e][n].length; o++) v.lineTo(r[e][n][o].x * p - b, r[e][n][o].y * p - y);
                v.clip()
            }
            var a = this.options.type, c = this._createCacheKey({x: s.x, y: s.y, z: g}),
                u = document.createElement("canvas"), l = u.getContext("2d");
            u.width = f.width, u.height = f.height, localforageExports.getItem(c).then(function (e) {
                var n, o;
                e ? ((n = new WorkerFactory).postMessage({
                    type: a,
                    imageData: e,
                    domainAndColor: i.options.domainAndColor
                }), n.onmessage = function (e) {
                    e = e.data;
                    "coloring" === e.type && (l.putImageData(e.result, 0, 0), t = v.createPattern(u, "repeat"), v.beginPath(), v.rect(0, 0, f.width, f.height), v.fillStyle = t, v.fill(), d())
                }) : ((o = new Image).src = m, o.crossOrigin = "anonymous", o.onload = function () {
                    var e, n;
                    f.complete = !0, l.drawImage(o, 0, 0, h, h), isColorDataType(a) ? (t = v.createPattern(u, "repeat"), v.beginPath(), v.rect(0, 0, f.width, f.height), v.fillStyle = t, v.fill(), d()) : (e = l.getImageData(0, 0, h, h), localforageExports.setItem(c, e), (n = new WorkerFactory).postMessage({
                        type: a,
                        imageData: e,
                        domainAndColor: i.options.domainAndColor
                    }), n.onmessage = function (e) {
                        e = e.data;
                        "coloring" === e.type && (l.putImageData(e.result, 0, 0), t = v.createPattern(u, "repeat"), v.beginPath(), v.rect(0, 0, f.width, f.height), v.fillStyle = t, v.fill(), d())
                    })
                })
            })
        }.bind(this), image.onload = function () {
        }, setTimeout(e, 0))
    }
};
L.TileLayer.RasterTile = L.TileLayer.extend({
    options: {polygons: null, mode: "show"}, includes: ExtendMethods, initialize: function (e, n) {
        var o;
        n = L.extend({}, L.TileLayer.prototype.options, {
            pickDataCallback: n.pickDataCallback,
            pickTrigger: n.pickTrigger || "hover",
            domainAndColor: n.domainAndColor || (null == (o = summary[n.type]) ? void 0 : o.domainAndColor),
            formatter: null == (o = summary[n.type]) ? void 0 : o.formatter,
            SHADOW_ZOOM: 5
        }, n), L.TileLayer.prototype.initialize.call(this, e, n), this._boundaryCache = {}, this._mercBoundary = null, this._mercBbox = null, this._tileImages = {}
    }, createTile: function (e, n) {
        var o = document.createElement("canvas"), t = this.getTileUrl(e);
        return o.width = o.height = this.options.tileSize, this._drawTileInternal(o, e, t, function () {
            n(null, o)
        }), o
    }, _createTileUrl: function (e) {
        var n = e.x, o = e.y, e = e.z, t = this.options, r = t.agg, i = t.token, a = t.type, t = t.time;
        return url+"/agg?agg=".concat(r, "&time=").concat(t, "&token=").concat(i, "&type=").concat(a, "&x=").concat(n, "&y=").concat(o, "&z=").concat(e)
    }, _createShadowMap: function (e) {
        var n = this, s = this, o = document.createElement("div"),
            t = (o.id = "shadow-map", o.style.width = "100%", o.style.height = "100%", o.style.position = "absolute", o.style.top = "0", o.style.left = "0", o.style.zIndex = "-10", o.style.pointerEvents = "none", o.style.opacity = 0, new L.Map(o, {
                center: e.getCenter(),
                zoom: this.options.SHADOW_ZOOM,
                minZoom: 0,
                maxZoom: this.options.SHADOW_ZOOM
            })), o = L.GridLayer.extend({
                createTile: function (e, t) {
                    var r = e.x, i = e.y, a = e.z, c = s.options.type, u = document.createElement("canvas"),
                        l = this.getTileSize(), f = s._createCacheKey({x: r, y: i, z: a});
                    return localforageExports.getItem(f).then(function (e) {
                        var n, o;
                        e ? (u.getContext("2d", {willReadFrequently: !0}).putImageData(e, 0, 0), (e = new Image).width = l.x, e.height = l.y, e.src = u.toDataURL(), s._tileImages[f] = e) : isColorDataType(c) || ((n = new Image).width = l.x, n.height = l.y, n.crossOrigin = "Anonymous", o = s._createTileUrl({
                            x: r,
                            y: i,
                            z: a
                        }), setTimeout(function () {
                            n.src = o, n.onload = function () {
                                u.setAttribute("width", l.x), u.setAttribute("height", l.y);
                                var e = u.getContext("2d", {willReadFrequently: !0}),
                                    e = (e.drawImage(n, 0, 0, l.x, l.y), e.getImageData(0, 0, l.x, l.y));
                                localforageExports.setItem(f, e), s._tileImages[f] = n
                            }, t(null, u)
                        }, 1e3))
                    }), u
                }
            });
        (this._shadowMap = t).addLayer(new o({
            minNativeZoom: 0,
            maxNativeZoom: s.options.SHADOW_ZOOM,
            bounds: this.options.bounds
        })), e.on("move", function () {
            t.setView(e.getCenter(), n.options.SHADOW_ZOOM)
        })
    }, onAdd: function (m) {
        var d = this, h = this, b = h.options.SHADOW_ZOOM,
            e = (this._createShadowMap(m), "hover" === this.options.pickTrigger ? "mousemove" : "click");
        m.on(e, function (e) {
            var n, o, t, r, i, a, c, u, l, f = h.options.type, s = m.getZoom();
            !isColorDataType(f) && h.options.pickDataCallback && (n = (o = m.project(e.latlng, s = b < s ? b : s)).x, o = o.y, t = (e = e.latlng).lat, e = e.lng, t = (e = _slicedToArray(getTileXyByZoomAndLngLat(e, t, s), 2))[0], e = e[1], r = (i = _slicedToArray(getTileBoundsByTileXy(t, e, s), 4))[0], i[1], i[2], i = i[3], r = (i = m.project({
                lat: i,
                lng: r
            }, s)).x, i = i.y, a = Math.trunc(n - r), c = Math.trunc(o - i), u = d._createCacheKey({
                x: t,
                y: e,
                z: s
            }), l = function (e) {
                var n = document.createElement("canvas"), n = (n.width = 256, n.height = 256, n.getContext("2d"));
                n.putImageData(e, 0, 0);
                var e = _slicedToArray(n.getImageData(a, c, 1, 1).data, 4), n = e[0], o = e[1], t = e[2], e = e[3];
                0 === n && 0 === o && 0 === t ? d.options.pickDataCallback(null) : d.options.formatter && (n = decoders[f]([n, o, t, e]), o = d.options.formatter(n), d.options.pickDataCallback(o || null))
            }, localforageExports.getItem(u).then(function (e) {
                var n;
                e ? l(e) : d._tileImages[u] ? (e = d._tileImages[u], (n = document.createElement("canvas").getContext("2d")).drawImage(e, a, c, 1, 1, 0, 0, 1, 1), e = n.getImageData(0, 0, 1, 1), l(e)) : d.options.pickDataCallback(null)
            }))
        }), L.GridLayer.prototype.onAdd.call(this)
    }, onRemove: function () {
        var e = document.getElementById("shadow-map");
        e && document.body.removeChild(e)
    }, setDomainAndColor: function (e) {
        if (0 === e.length) throw"值域和颜色数组的长度必须大于0";
        if (!e.every(function (e) {
            return hexColorReg.test(e.color)
        })) throw"颜色值不合法";
        e.some(function (e) {
            if (void 0 === e.min && void 0 === e.max) throw"值域和颜色的min和max不能同时为undefined"
        }), this.options.domainAndColor = e, this.redraw(), this._tileImages = {}, isColorDataType(type) || this._shadowMap.eachLayer(function (e) {
            e.redraw(!0)
        })
    }, resetUrl: function () {
        var e = this.options, n = e.agg, o = e.time, t = e.token, e = e.type;
        this.setUrl(url+"/agg?agg=".concat(n, "&time=").concat(o, "&token=").concat(t, "&type=").concat(e, "&x={x}&y={y}&z={z}"))
    }, setType: function (e) {
        var n;
        this.options.type = e, this.options.domainAndColor = null == (n = summary[e]) ? void 0 : n.domainAndColor, this.options.formatter = null == (n = summary[e]) ? void 0 : n.formatter, this.resetUrl(), this.redraw(), this._tileImages = {}, isColorDataType(e) || this._shadowMap.eachLayer(function (e) {
            e.redraw(!0)
        })
    }, setAgg: function (e) {
        this.options.agg = e, this.resetUrl(), this.redraw(), this._tileImages = {}, isColorDataType(type) || this._shadowMap.eachLayer(function (e) {
            e.redraw()
        })
    }, setTime: function (e) {
        this.options.time = e, this.resetUrl(), this.redraw(), this._tileImages = {}, this._shadowMap.eachLayer(function (e) {
            e.redraw()
        })
    }, getCurrentDomainAndColor: function () {
        return this.options.domainAndColor
    }, setPolygons: function (e) {
        return this.options.polygons = e, this._boundaryCache = {}, this._mercBoundary = null, this._mercBbox = null, this._tileImages = {}, this.redraw(), this
    }, getPolygons: function () {
        return this.options.polygons
    }
}), L.TileLayer.rasterTile = function (e) {
    if (!e.type) throw"The type option is required.";
    var n = Object.keys(summary);
    if (![].concat(n, ["DCOLOR", "TCOLOR"]).includes(e.type)) throw"The type option should be one of " + n.join(", ") + ". Got: " + e.type;
    if (!e.token) throw"The token option is required.";
    if (!e.time) throw"The time option is required.";
    if (!e.agg) throw"The agg option is required.";
    if (e.domainAndColor) {
        if (!Array.isArray(e.domainAndColor)) throw"The domainAndColor option should be an array.";
        if (0 === e.domainAndColor.length) throw"The domainAndColor option should not be an empty array."
    }
    e.bounds || console.warn("设置正确的bounds可过滤不需要的瓦片请求，有效提高瓦片加载效率");
    var n = e.agg, o = e.time, t = e.token, r = e.type;

    let resUrl =  new L.TileLayer.RasterTile(url+"/agg?agg=".concat(n, "&time=").concat(o, "&token=").concat(t, "&type=").concat(r, "&x={x}&y={y}&z={z}"), e)
    return resUrl
};
